import ImageGallery from 'react-image-gallery';
import './index.scss';
import styled from 'styled-components';
import { RenderLeftNav, RenderRightNav } from './components/nav';
import { useMemo } from 'react';
import { openFullScreenWithId, useImages } from 'services/viewVehicleSlice/viewVehicleSlice';
import { useDispatch } from 'react-redux';
import ReactImageGallery from 'react-image-gallery';
import AutoPlayVideo from 'components/AutoPlayVideo';
import { SectionImage } from 'services/api/vehicle-sections/types';
import GptIcon from 'components/Icons/gpt.svg';

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 16px;
  max-width: 640px;

  @media (min-width: 1800px) {
    max-width: 800px;
  }
`;

const PreviewImage = styled.div<{ showNextButton?: boolean }>`
  border-radius: 30px;
  position: relative;
  aspect-ratio: 4 / 3;

  & > img {
    border: 1px solid rgba(204, 204, 204, 1);
    border-radius: 30px;
    width: 100%;
    height: 100%;
    opacity: ${props => (props.showNextButton ? '0.6' : '1')};
    cursor: pointer;
  }

  @media (max-width: 1024px) {
    & > img {
      border-radius: 20px;
    }
  }
`;

const videoStyles = {
  borderRadius: '30px',
  position: 'relative',
  objectFit: 'cover',
  aspectRatio: '4/3'
};

const PreviewVideo = styled(AutoPlayVideo)`
  video {
    width: 100%;
    min-width: 300px;
    border-radius: 30px;
    position: relative;
    object-fit: cover;
    aspect-ratio: 4 / 3;
  }
`;

const PlayImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  cursor: pointer;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ImagePreviewWrapper = styled.div<{ expanded?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: calc((100% - (3 * 8px)) / 4);
  gap: 8px;
  overflow-x: ${props => (props.expanded ? 'auto' : 'hidden')};

  @media (max-width: 1024px) {
    grid-auto-columns: calc((100% - (3 * 4px)) / 4);
    gap: 4px;
  }
`;

const Plus4Label = styled.div`
  font-weight: 700;
  font-style: Bold;
  font-size: 32px;
  line-height: 100%;
  color: #fff;
`;

const IconWrapper = styled.span`
  & svg {
    transform: translateY(10px);
  }
`;

type Props = {
  imageGalleryRef: React.RefObject<ReactImageGallery>;
  images: SectionImage[];
  handleClick?: () => void;
};

export const VehicleImageCarousel = ({ imageGalleryRef, images, handleClick }: Props) => {
  const mappedImages = useMemo(
    () =>
      images.map(i => ({
        original: i.url!,
        thumbnail: i.url_thumb,
        description: i.notes?.message ? (
          <span>
            <IconWrapper style={{ marginRight: '4px', transform: 'translateY(40px)' }}>
              <GptIcon />
            </IconWrapper>
            {i.notes.message}
          </span>
        ) : (
          ''
        )
      })),
    [images.length]
  );

  return (
    <ImageGallery
      ref={imageGalleryRef}
      showPlayButton={false}
      showFullscreenButton={false}
      onClick={handleClick}
      renderLeftNav={(onclick, disabled) => <RenderLeftNav onClick={onclick} disabled={disabled} />}
      renderRightNav={(onclick, disabled) => <RenderRightNav onClick={onclick} disabled={disabled} />}
      items={mappedImages as any[]}
      showIndex
      useBrowserFullscreen={false}
      showThumbnails={false}
      infinite={true}
    />
  );
};
